"use client";
//#region packages/@mantine/core/src/components/ActionIcon/ActionIcon.module.css
var ActionIcon_module_default = {
	"root": "m_8d3f4000",
	"icon": "m_8d3afb97",
	"loader": "m_302b9fb1",
	"group": "m_1a0f1b21",
	"groupSection": "m_437b6484"
};
//#endregion
export { ActionIcon_module_default as default };

//# sourceMappingURL=ActionIcon.module.mjs.map